var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.block.sound)?_c('audio',{ref:"sound",attrs:{"src":_vm.block.sound.url}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }